import { StopCircle } from 'lucide-react';
import { LucideProps } from 'lucide-react';
import { CheckCircle, AlertCircle, AlertTriangle } from 'lucide-react';

import { NotificationCountData } from '@rta/rta-blueprint-library';

import { lang } from '@lang';
import { useDesign } from '@hooks';
import { ContextPanelMode, pushContextPanel, useAppDispatch } from '@state';
import { Feature, FeatureHoookParams } from '..';

import type { JSX } from "react";

const statusList: Record<string, {
	icon: (props: LucideProps) => JSX.Element;
	color: string;
	label: string;
}> = {
	good: {
		icon: (props = {}) => <CheckCircle {...props} style={{ color: '#48BB78' }} />,
		color: '#48BB78',
		label: lang.blueprintStatus.label.good
	},
	warn: {
		icon: (props = {}) => <AlertTriangle {...props} style={{ color: '#ED8936' }} />,
		color: '#ED8936',
		label: lang.blueprintStatus.label.warn
	},
	error: {
		icon: (props = {}) => <AlertCircle {...props} style={{ color: '#F56565' }} />,
		color: '#F56565',
		label: lang.blueprintStatus.label.error
	},
	critical: {
		icon: (props = {}) => <StopCircle {...props} style={{ color: '#E53E3E' }} />,
		color: '#E53E3E',
		label: lang.blueprintStatus.label.critical
	}
};

type BlueprintStatusFeatureParams = FeatureHoookParams;
export const showBlueprintStatusFeature = (_params: BlueprintStatusFeatureParams = {}): Feature<string> => {
	const dispatch = useAppDispatch();
	const [controller] = useDesign();

	const kitchen = controller?.kitchen ?? null;
	const notifications = kitchen?.design.notifications ?? null;
	const notificationCount = notifications?.getCounts() ?? null;
	// const notificationCount = { total: 1, info: 1, warn: 0, error: 0, critical: 0 };

	let blueprintStatus = 'good';

	if (notificationCount && notificationCount.total > 0) {
		const determineIconToShow = (notificationType: NotificationCountData) => {
			if (notificationType?.critical > 0) return 'critical';
			if (notificationType?.error > 0) return 'error';
			if (notificationType?.warn > 0) return 'warn';
			return 'good';
		};
		blueprintStatus = determineIconToShow(notificationCount);
	}

	const [enabled, tooltip] = (() => {
		if (controller === null) return [false, lang.blueprintStatus.tooltip.noDesign];
		if (notificationCount?.total === 0) return [false, lang.blueprintStatus.tooltip.noNotifications];
		return [true, statusList[blueprintStatus].label];
	})();

	// console.log(statusList[blueprintStatus]);

	return {
		name: 'blueprintStatus',
		label: statusList[blueprintStatus].label,
		shortcut: '',
		tooltip,
		icon: (props = {}) => statusList[blueprintStatus].icon(props),
		color: statusList[blueprintStatus].color,
		disabled: !enabled,
		value: blueprintStatus,
		hidden: false,
		handler: () => {
			if (notificationCount && notificationCount.total > 0) {
				dispatch(pushContextPanel({ mode: ContextPanelMode.BlueprintValidation }));
			}
		}
	};
};
